export function formatUpdateDate(value?: string) {
  if (!value) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return String(value).slice(0, 10)

  const now = new Date()
  const startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const startDay = new Date(d.getFullYear(), d.getMonth(), d.getDate())
  const diffDays = Math.round((startToday.getTime() - startDay.getTime()) / 86400000)

  if (diffDays === 0) return 'Сегодня'
  if (diffDays === 1) return 'Вчера'
  if (diffDays > 1 && diffDays < 7) return `${diffDays} дн. назад`

  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
}

export function bodyParagraphs(body: string): string[] {
  return String(body || '')
    .split(/\n+/)
    .map((p) => p.trim())
    .filter(Boolean)
}

export type UpdatesFilter = 'all' | 'new'

export function filterUpdates<T extends { id: number; tag?: string | null }>(
  items: T[],
  filter: UpdatesFilter,
  highlightIds: Set<number>,
  tag: string | null,
): T[] {
  return items.filter((item) => {
    if (filter === 'new' && !highlightIds.has(item.id)) return false
    if (tag && item.tag !== tag) return false
    return true
  })
}

export function uniqueTags(items: { tag?: string | null }[]): string[] {
  const set = new Set<string>()
  items.forEach((item) => {
    if (item.tag) set.add(item.tag)
  })
  return [...set]
}
